import { Component, OnInit, ViewChild } from '@angular/core';

import { CustomStore, ArkUnitOfWork, BreezeDxStoreService, AuthService, AppInformationService } from 'app/core/core.module';
import { ActivatedRoute, Router } from '@angular/router';
import { PeopleModule } from '../people.module';
import { Person } from 'app/core/model/entity-model';
import { DevExtremeModule, DxDataGridComponent } from 'devextreme-angular';
import { UtilityService } from 'app/core/data/utility.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import moment from 'moment';

@Component({
    selector: 'app-families-list',
    templateUrl: './families-list.component.html',
    styleUrls: ['./families-list.component.scss'],
    imports: [DevExtremeModule]
})
export class FamiliesListComponent implements OnInit {
    store: CustomStore;
    families: any[];
    households: any;
    filter: any;
    canPrintMemberSheets = false;
    canPrintCalendar = false;
    startDate: Date;
    endDate: Date;
    peopleAdmin = false;


    @ViewChild('familiesGrid') dataGrid: DxDataGridComponent;

    constructor(
        private uow: ArkUnitOfWork,
        private storeService: BreezeDxStoreService,
        private route: ActivatedRoute,
        private router: Router,
        public auth: AuthService,
        public appInfo: AppInformationService,
        private modalService: BsModalService,
        private utility: UtilityService
    ) {}

    async ngOnInit() {
        const today = new Date();
        this.filter = {};
        this.households = await this.uow.getHouseholds();
        this.families = await this.uow.getFamilies();
        this.canPrintMemberSheets = this.auth.hasRole('Administrator') || this.auth.hasRole('Secretary');
        this.canPrintCalendar = this.auth.hasRole('Administrator') || this.auth.hasRole('Secretary');
        this.filter.startDate = moment(today).startOf('month').add(1, 'month').toDate();
        this.filter.endDate = moment(today).endOf('month').add(2, 'month').toDate();
        this.peopleAdmin = this.auth.hasRole('PeopleAdmin');
    }

    getStore() {
        const query = this.uow.people.baseQuery();
        this.store = this.storeService.createStore(this.uow, this.uow.people, query, 'id', 'lastName');
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'before',
            },

        );
    }

    rowDoubleClick(e) {
        if (!e.data || !e.data.id) return;
        this.addOpen(e.data.id);
    }

    addOpen(familyId?: number) {
        if (!this.peopleAdmin) return;
        // this.router.navigate(['new'], { relativeTo: this.route });
        this.router.navigate(['/people/families/' + (familyId ? familyId : 'new')]);
    }

    assignHousehold(selectedRows: any) {
        console.log(selectedRows);
        if (!selectedRows || selectedRows.length === 0) return;
        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                mode: 'selectWithId',
                dialogHeader: 'Households',
                dialogValueArray: this.households,
                checkNumeric: false,
                checkInteger: false,
                saveAndNewVisible: false,
                autoSaveIfNotEmpty: true,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success && !!result.value) {
                this.appInfo.pleaseWaitShow();
                selectedRows.forEach((family) => {
                    family.householdId = result.value;
                });
                await this.uow.commit();
            }
            modalRef.hide();
            this.appInfo.pleaseWaitHide();
        });
    }

    async printMemberInfo() {
        await this.utility.printMemberInfoSheets();
    }

    async printMemberCalendar() {
        await this.utility.printMemberCalendar(this.filter);
    }
}
